/* Gerber footer: link columns are accordions below 750px and always open above it. */
(function () {
  var mq = window.matchMedia('(min-width: 750px)');

  function sync() {
    document.querySelectorAll('.g-footer [data-gf-col]').forEach(function (col) {
      var summary = col.querySelector('summary');
      col.open = mq.matches;
      if (summary) summary.tabIndex = mq.matches ? -1 : 0;
    });
  }

  document.addEventListener('click', function (event) {
    var summary = event.target.closest && event.target.closest('.g-footer summary');
    if (summary && mq.matches) event.preventDefault();
  });

  /* Copyright year: Shopify caches pages, so set the year from the visitor's clock. The server-rendered
     year in the markup stays as the fallback when JavaScript is off. */
  function setYear() {
    var year = String(new Date().getFullYear());
    document.querySelectorAll('[data-gf-year]').forEach(function (el) {
      if (el.textContent !== year) el.textContent = year;
    });
  }

  document.addEventListener('shopify:section:load', function () {
    sync();
    setYear();
  });
  if (mq.addEventListener) mq.addEventListener('change', sync);
  else mq.addListener(sync);
  sync();
  setYear();
})();
